/** Translation in components: the reader's language, from the store. scope.md §10. */

import { Fragment, type ReactNode } from 'react';
import {
  type ContractShape, type Locale, type ServerErrorCode, type Translate,
  describeContractIn, secondsText, translator,
} from '@garbage/shared';
import { useGame } from './store.js';

export function useLocale(): Locale {
  return useGame((state) => state.locale);
}

export function useT(): Translate {
  return translator(useLocale());
}

/** "1 set of 3 and 1 run of 4" in the reader's language. */
export function useContractText(): (contract: ContractShape) => string {
  const t = useT();
  return (contract) => describeContractIn(t, contract);
}

export function useSecondsText(): (ms: number) => string {
  const t = useT();
  return (ms) => secondsText(t, ms);
}

/** A dictionary string with `**bold**` in it, as elements. */
export function Rich({ text }: { text: string }): ReactNode {
  const parts = text.split('**');
  return (
    <>
      {parts.map((part, i) => (i % 2 === 1
        ? <strong key={i}>{part}</strong>
        : <Fragment key={i}>{part}</Fragment>))}
    </>
  );
}

/**
 * What to show for something the server refused. The engine's own refusals only have
 * English wording, which is more useful than a generic line — to an English reader.
 */
export function refusalText(t: Translate, locale: Locale, message: string, code: ServerErrorCode | null): string {
  if (!code) return message;
  if (code === 'notAllowed' && locale === 'en-GB') return message;
  return t(`serverError.${code}`);
}
